export const chartColumns = [
  {
    field: 'contractSignDate',
    title: '合同签订时间',
    width: '120',
  },
  {
    field: 'contractCode', ///
    title: '合同编号',
    width: '150',
  },
  {
    field: 'contractName',
    title: '合同名称',
    width: '140',
  },
  {
    field: 'signTitle',
    title: '签约抬头',
    width: '140',
  },
  {
    field: 'customerName',
    title: '客户名称',
    width: '140',
  },
  // {
  //   field: 'supplierName',
  //   title: '供方名称',
  //   width: '140',
  // },
  {
    field: 'chargePersonName',
    title: '经办人员',
    width: '140',
  },
  {
    field: 'contractType',
    title: '合同类型',
    width: '140',
  },
  {
    field: 'contractTotalAmount',
    title: '合同金额',
    width: '140',
  },
  {
    field: 'serviceTypeName',
    title: '合同产品服务',
    width: '140',
  },
  {
    field: 'contractEffectDate',
    title: '合同生效日期',
    width: '140',
  },
  {
    field: 'contractExpireDate',
    title: '合同失效日期',
    width: '140',
  },
];
